import { AuthConfig, PersonalPath, PublicPath } from '@/config/auth'
import useGlobalStore from '@/store/useGlobalStore'
import { isPersonal } from '@/utils/help'
import { useShallow } from 'zustand/react/shallow'

export function useAuth() {
  const {
    authCodes,
    userInfo,
  } = useGlobalStore(useShallow(s => ({
    authCodes: s.authCodes,
    userInfo: s.userInfo,
  })))

  // 是否是个人系统
  const getAuthPathByCodes = authCodes => {
    const { basicConfigInfo } = useGlobalStore.getState()
    const resSet = new Set(PublicPath)
    AuthConfig.forEach(item => {
      // 获取 code 的中间部分 1 级和 2 级目录
      // const authCode = item.code.split(':').slice(0, 3).join(':')
      const authCode = item.code
      // const findConfigItem = authCodes.includes(item.code)
      const findConfigItem = authCodes.find(code => code.includes(authCode))
      if (findConfigItem) {
        resSet.add(item.path)
      }
      // code 为空默认有权限
      if (!item.code) {
        // 其他权限，超管和默认企业权限鉴权
        if (item.auth) {
          let isAllowed = true;
          const auth = item.auth;
          // Check superAdmin permission if it exists
          if ('isSuperAdmin' in auth) {
            isAllowed = isAllowed && (auth.isSuperAdmin === basicConfigInfo.isSuperAdmin);
          }

          // Check defaultEpid permission if it exists
          if ('isDefaultEpid' in auth) {
            isAllowed = isAllowed && (auth.isDefaultEpid === basicConfigInfo.isDefaultEpid);
          }
          if (isAllowed) {
            resSet.add(item.path)
          }
        } else {
          resSet.add(item.path)
        }
      }

    })
    // 处理个人空间问题。如果是个人空间，需要添加默认路径 /cost/list
    // if (isPersonal()) {
    //   PersonalPath.forEach(path => {
    //     resSet.add(path)
    //   })
    // }
    return Array.from(resSet)
  }

  const hasAuth = (code, ownerId?: string) => {
    // console.log('hasAuth', code, ownerId, userInfo)
    if (isPersonal()) return true
    if (ownerId && userInfo?.userName && ownerId === userInfo.userName) return true
    return authCodes.includes(code)
  }


  return { codes: authCodes, hasAuth, getAuthPathByCodes }
}
